import React, {Component} from "react";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import loadingImg from '../../../../../assets/img/loading.gif';

class CancelledOrdersTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            refundFailDialogShow : false,
            refundProgress : true
        };

        this.handleShowRefundConfirm = this.handleShowRefundConfirm.bind(this);
        this.handleCloseRefundConfirm = this.handleCloseRefundConfirm.bind(this);
        this.refundOrder = this.refundOrder.bind(this);
        this.refundOrderPayment = this.refundOrderPayment.bind(this);
        this.handleCloseRefundFailDialog = this.handleCloseRefundFailDialog.bind(this);

    }

    handleCloseRefundFailDialog = () => {
        this.setState({
            refundFailDialogShow: false
        })
    };

    handleShowRefundConfirm = () => {
        this.setState({
            show: true
        })
    };

    handleCloseRefundConfirm = () => {
        this.setState({
            show: false
        })
    };

    refundOrder = () => {
        this.setState({
            refundProgress : false
        }, ()=>this.refundOrderPayment(this.props.orders.id, this.props.orders.paymentRefId));

    };


    refundOrderPayment = (orderId, paymentId) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/payment/order/'+orderId+'/refund/'+paymentId, axiosConfig)
            .then((res) => {
                console.log("REFUND SUCCESS =====> ", res.data);

                if(res.data.refunded){
                    this.setState({
                        show :false,
                        refundProgress : true
                    }, () => this.props.getCancelledOrders(0,5));
                }else {
                    this.setState({
                        show :false,
                        refundFailDialogShow : true,
                        refundProgress : true
                    }, () => this.props.getCancelledOrders(0,5));
                }

            })
            .catch((err) => {
                console.log("[API] ERROR REFUND: ", err);
                this.setState({
                    show : false,
                    refundFailDialogShow : true,
                    refundProgress : true
                })
            });
    };

    render() {
        return (

            <tr>
                <td><span>{this.props.orders.orderBatchNumber}</span></td>
                <td>
                     <span>   {this.props.orders.createdDate.substring(0, 4)}年 {this.props.orders.createdDate.substring(5, 7)}月&nbsp;
                         {this.props.orders.createdDate.substring(8, 10)}日</span>
                </td>
                <td>
                    <div>{this.props.orders.orderShippingAddress.lastName}&nbsp;{this.props.orders.orderShippingAddress.firstName}</div>
                    <div>{this.props.orders.orderShippingAddress.postalCode}</div>
                    <div>{this.props.orders.orderShippingAddress.province}&nbsp;{this.props.orders.orderShippingAddress.city}</div>
                    <div>{this.props.orders.orderShippingAddress.streetAddress}</div>
                    <div>{this.props.orders.orderShippingAddress.addressLine2}</div>
                    <div>{this.props.orders.orderShippingAddress.billContact}</div>
                </td>
                <td>
                    <span>
                        {this.props.orders.paymentAmount !== null ?
                            <NumberFormatter num={this.props.orders.paymentAmount}/> : 0}

                    </span>
                </td>
                <td>
                    {this.props.orders.refundedDate !== null ?
                        <span>{this.props.orders.refundedDate.substring(0, 4)}年 {this.props.orders.refundedDate.substring(5, 7)}月&nbsp;
                            {this.props.orders.refundedDate.substring(8, 10)}日</span>
                        :
                        <span>まだ払い戻しされていません</span>
                    }
                </td>
                <td>
                    <Link to={"view/" + this.props.orders.id} className="btn btn-xs btn-warning action-btn">
                        <FormattedMessage id="app.admin-all-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>

                    {this.props.orders.refunded ?
                        <button className="btn btn-xs btn-danger action-btn" disabled={true}>
                            払い戻し済み
                        </button>
                        :

                        <button className="btn btn-xs btn-success refund-btn action-btn" onClick={this.handleShowRefundConfirm}>
                            払い戻し
                        </button>
                    }

                    {/*confirm refund ------------------------------*/}
                    <Modal dialogClassName="confirm-refund-modal" show={this.state.show}
                           onHide={this.handleCloseRefundConfirm}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                払い戻しを確認
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-12 data-label">
                                        この注文の金額を払い戻ししてもよろしいですか？
                                    </div>
                                </div>
                                <div className="row" hidden={this.state.refundProgress}>
                                    <div className="col-md-12 text-danger data-label">
                                        払い戻し中 &nbsp;
                                        <img src={loadingImg} width={70}/>
                                    </div>
                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">
                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.handleCloseRefundConfirm}>
                                    いいえ
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes" onClick={this.refundOrder}>
                                    はい
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/*refund failed dialog ------------------------------*/}
                    <Modal dialogClassName="confirm-refund-modal" show={this.state.refundFailDialogShow}
                           onHide={this.handleCloseRefundFailDialog}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                払い戻しに失敗しました
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-12 data-label">
                                        払い戻しに失敗しました。もう一度試してください。
                                    </div>
                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">
                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.handleCloseRefundFailDialog}>
                                    閉じる
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                </td>
            </tr>
        )
    }
}

export default CancelledOrdersTableRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CancelledOrder/CancelledOrdersTable/CancelledOrdersTableRow.js